// 公共api 接口封装
import http from './http.js' // 接口统一调用方法

// 轮播图接口
export const homeAdvertiseList = (data) => {
  return http.get('/mall-portal/home/homeAdvertiseList', data)
}
